import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface DriverDelays1pDeliveryOrdersProps extends BaseTemplateProps {
  minutes: string
  actionUrl: string
}

export const DriverDelays1pDeliveryOrders: TemplateDefinition<DriverDelays1pDeliveryOrdersProps> = {
  renderParams: (props: DriverDelays1pDeliveryOrdersProps) => ({
    messageKey: 'notificationsDomain.templates.driverDelays1pDeliveryOrders',
    values: {
      minutes: props.minutes,
    },
  }),
  getLink: (props: DriverDelays1pDeliveryOrdersProps): string => props?.actionUrl || '',
}
